// We put here all the variables that should be constant and reused across the entire application.
// Easy configuration if we need to make some changes.

export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = "e54e2b7a-661f-4153-b4a7-9e381c328aaf";
export const MODAL_CLOSE_SEC = 2.5;
